import { render, staticRenderFns } from "./show.content-blocks.page.vue?vue&type=template&id=d5004d9c&"
import script from "./show.content-blocks.page.vue?vue&type=script&lang=js&"
export * from "./show.content-blocks.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports